import UIDs from "../../../../../UIDs";

const uid = UIDs.screens.admin.homework.unitpreview;

const ActionTypes = {
    LOAD_SCREEN_VIEW_ASYNC: `${uid}.loadScreenViewAsync`,
    LOAD_SCREEN_VIEW_SUCCESS: `${uid}.loadScreenViewSuccess`,
    LOAD_SCREEN_VIEW_FAILURE: `${uid}.loadScreenViewFailure`,
    EDIT_UNIT_ANSWER: `${uid}.editUnitAnswer`,
    VIEW_UNIT_ANSWER: `${uid}.viewUnitAnswer`,
    SHOW_REPORT_ERROR: `${uid}.showReportError`,
    SAVE_REFERENCE_ANSWER_ASYNC: `${uid}.saveReferenceAnswerAsync`,
    SAVE_REFERENCE_ANSWER_SUCCESS: `${uid}.saveReferenceAnswerSuccess`,
    SAVE_REFERENCE_ANSWER_FAILURE: `${uid}.saveReferenceAnswerFailure`,
    REPORT_ERROR_ASYNC: `${uid}.reportErrorAsync`,
    REPORT_ERROR_SUCCESS: `${uid}.reportErrorSuccess`,
    REPORT_ERROR_FAILURE: `${uid}.reportErrorFailure`,
};

export { ActionTypes };
